import { UseQueryOptions } from '@tanstack/react-query';
import { GenericTradeParams, TpSlValueState } from '@ui/features/Trade/types';
import { SlValidationResult } from '@ui/features/Trade/utils/validateStoppLossPrice';
import { TpValidationResult } from '@ui/features/Trade/utils/validateTakeProfitPrice';
import { useGasFee } from '@ui/hooks/useGasFee';
import type { DecreaseOrderRow } from '@ui/services/contract/hooks/TradingPortalFacet/useDecreaseOrders/types';

import { EditTpSlBaseline } from './getEditTpSlBaseline';
import { useEditTpSlConfirmBtnDisabled } from './useEditTpSlConfirmBtnDisabled';
import { useEstTradeEditTpSlGasLimit } from './useEstTradeEditTpSlGasLimit';

export const useEstTradeUpdateTpSlGasFee = <TSelect = BigInt>({
  baseline,
  genericTradeParams,
  activeDecreaseOrders,
  tp,
  sl,
  tpValidation,
  slValidation,
  opts,
}: {
  baseline: EditTpSlBaseline | null;
  tp: TpSlValueState;
  sl: TpSlValueState;
  activeDecreaseOrders?: DecreaseOrderRow[];
  tpValidation: TpValidationResult | undefined;
  slValidation: SlValidationResult | undefined;
  opts?: Pick<UseQueryOptions<BigInt, Error, TSelect>, 'enabled'>;
} & GenericTradeParams) => {
  const isConfirmBtnDisabled = useEditTpSlConfirmBtnDisabled({
    baseline,
    tp,
    sl,
    tpValidation,
    slValidation,
  });

  const { data: estimateUpdateTpSlGasLimit } = useEstTradeEditTpSlGasLimit({
    genericTradeParams,
    activeDecreaseOrders,
    tp,
    sl,
    opts: {
      enabled:
        !isConfirmBtnDisabled && (opts?.enabled ?? true),
    },
  });

  return useGasFee(estimateUpdateTpSlGasLimit);
};
